import { getRedPlusIdsFromSails } from '@vfde-sails/storage';
import { RedplusTariff } from '@vfde-sails/constants';
import { SailsTariffOverviewStorage } from 'Container/App/interface';

/**
 * Get Red+ IDs
 */
export const getRedPlusIds = (storage: SailsTariffOverviewStorage | null): RedplusTariff[] => {
    if (!storage) {
        return [];
    }

    return getRedPlusIdsFromSails(storage);
};
